// Keep floating editors on the right edge of the pitch, below the camera
// controls and above the timeline/zoom area. Scroll only within that gap.
export const contextPanelPosition = (bottomClearance = 0) => ({
  position: 'absolute',
  top: 'var(--kv-context-effective-top)',
  right: '8px',
  maxHeight: `calc(var(--kv-viewport-h) - var(--kv-context-effective-top) - ${bottomClearance}px)`,
  overflowY: 'auto',
});

export function ContextCloseBar({ label, onClick }) {
  return <button type="button" className="kv-context-close-bar" aria-label={label} onClick={onClick}>{label}</button>;
}
